import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { BulkUpdateWatchlistOrderValues, WatchlistModel } from '@model/DxTrade.types'

export const useBulkUpdateWatchlistOrderValues = () => {
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: BulkUpdateWatchlistOrderValues): Promise<void> =>
      apiClient.bulkUpdateWatchlistOrderValues(payload),
    onMutate: async (payload) => {
      await queryClient.cancelQueries({ queryKey: ['trade', 'dxtrade', 'watchlists'] })
      const previousData = queryClient.getQueriesData<WatchlistModel[]>({
        queryKey: ['trade', 'dxtrade', 'watchlists'],
      })
      const orderMap = new Map(payload.orderValues?.map((o) => [o.id, o.orderValue]) ?? [])
      queryClient.setQueriesData<WatchlistModel[]>(
        { queryKey: ['trade', 'dxtrade', 'watchlists'] },
        (old) =>
          old?.map((w) => (orderMap.has(w.id) ? { ...w, orderValue: orderMap.get(w.id) } : w))
      )
      return { previousData }
    },
    onError: (_err, _variables, context) => {
      context?.previousData.forEach(([queryKey, data]) => {
        queryClient.setQueryData(queryKey, data)
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['trade', 'dxtrade', 'watchlists'] })
    },
  })
}
